/**
 * Indicates how many dialogs are nested within.
 * @type {number}
 */
export const nestedDialogs = '--nested-dialogs';